import { z } from 'zod';
import type { RoutePointSimpleType } from '../../../utilities/RoutePointsApi';
import { RoutePointSimpleSchema } from '../../../utilities/RoutePointsApi';

export function getRoutePointIfExists(
    // realisation_status: RealisationStatusType,
    route_points: RoutePointSimpleType[],
    jobId: number
): RoutePointSimpleType | undefined {
    route_points = z.array(RoutePointSimpleSchema).parse(route_points);
    // realisation_status = RealisationStatusSchema.parse(realisation_status);
    return route_points?.find((rp: RoutePointSimpleType) => {
        if (rp?.details?.delivered === null) {
            return false;
        }
        if (typeof rp?.details?.delivered === 'undefined') {
            return false;
        }
        let jobIds = Object.keys(rp.details.delivered).map(s => parseInt(s));
        return jobIds.includes(jobId);
    });
}
